import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
// componentes
import TableHotel from "../../Hotel/tableHotel";
import ModalNewHotel from "../../Hotel/ModalNewHotel";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";
// service
import { getHotel } from "../../../../utils/services/hotel";

export default function Hotel(props) {
  const { idEvent, participants, user } = props;
  const [hotels, setHotels] = useState([]);
  // modal
  const [modalNewHotel, setModalNewHotel] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);

  function getData() {
    setLoading(true);
    getHotel({
      idEvent: idEvent,
      offset: 1,
      limit: 10,
      search: user.id,
      columnSearch: "id",
    })
      .then((res) => {
        if (
          res.message === "HOTELS_BY_EVENT" &&
          res.findOneHotelData.count > 0
        ) {
          setHotels(res.findOneHotelData.data);
        } else setHotels([]);
      })
      .catch(() => {
        toast.error("Erro ao carregar hotéis.");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (user?.id) {
      getData();
    }
  }, [user.id]);

  return (
    <>
      {modalNewHotel && (
        <ModalNewHotel
          isOpen={modalNewHotel}
          toggle={() => setModalNewHotel(false)}
          idEvent={idEvent}
          data={getData}
          participants={participants}
          user={user}
        />
      )}

      <div className="my-3">
        <div className="d-flex justify-content-end">
          <ActionButtonRounded
            title="Adicionar Hotel"
            onClick={() => setModalNewHotel(true)}
            className="btn-rounded waves-effect waves-light events-button-add mb-2"
          />
        </div>

        {loading ? (
          <LoadingSkelentonTable lines={5} cols={4} />
        ) : (
          <TableHotel
            hotels={hotels}
            idEvent={idEvent}
            participants={participants}
            data={getData}
          />
        )}
      </div>
    </>
  );
}
